import { render, staticRenderFns } from "./whatIf.vue?vue&type=template&id=1f3f446e&scoped=true&"
import script from "./whatIf.vue?vue&type=script&lang=js&"
export * from "./whatIf.vue?vue&type=script&lang=js&"
import style0 from "./whatIf.vue?vue&type=style&index=0&id=1f3f446e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3f446e",
  null
  
)

export default component.exports